import http from '@/plugins/http';

export default (params) => new Promise((res, rej) => {
  const data = {
    email: params.email,
    token: params.token,
    code: params.code,
    client_id: '1_3vphdvfsk0sggg8k8ockc0gcw4s040gowocko8gk4s8sok8gc',
    client_secret: 'xdpwhf9uon4ws8g4ss40gcsokk4wwws800sk8kgsowkkcs8o4',
    from: 'customer_site',
  };
  http.put('/v3/users/auth0/attach_account_confirmation', data)
    .then((response) => {
      res(response.data);
    }, (response) => {
      rej(response);
    });
});
